import { StyleSheet } from 'react-native';

export const style = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: 24,
    gap: 24,
  },
  cardsWrapper: {
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center',
  },
  ctaWrapper: {},
});
